<template>
    <div>
        <div class="form-group col-12">
            <label for="name">Name</label>
            <input
                id="name"
                v-model="event.name"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': hasError('name')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('name') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="date">Date</label>
            <input
                id="date"
                v-model="event.date"
                type="datetime-local"
                class="form-control"
                :class="{
                    'is-invalid': hasError('date')
                }"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('date') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="price">Price</label>
            <currency-input
                id="price"
                v-model="event.price"
                class="form-control"
                :class="{
                    'is-invalid': hasError('price')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('price') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="location">Location</label>
            <input
                id="location"
                v-model="event.location"
                class="form-control"
                :class="{
                    'is-invalid': hasError('location')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('location') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="description">Description</label>
            <wysiwyg-editor
                id="description"
                v-model="event.description"
                :error-border="hasError('description')"
                :class="{ 'is-invalid': hasError('description') }"
            />

            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>
        <div class="form-group col-12">
            <content-builder
                v-model="event.content"
                label="Content"
                :sections="{
                    header: false,
                    double: true,
                    form: false
                }"
            />

            <div class="invalid-feedback">
                {{ getError('description') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label for="name">Pay With Stars</label>
            <b-form-checkbox v-model="event.payWithStars" switch />

            <div class="invalid-feedback">
                {{ getError('payWithStars') }}
            </div>
        </div>
        <div class="form-group col-12">
            <label>Add another price for Aguda members</label>
            <b-form-checkbox v-model="isAgudaPriceEnabled" switch />
        </div>
        <div v-show="isAgudaPriceEnabled" class="form-group col-12">
            <label for="agudaPrice">Aguda members price</label>
            <currency-input
                id="agudaPrice"
                v-model="event.agudaPrice"
                class="form-control"
                :class="{
                    'is-invalid': hasError('agudaPrice')
                }"
            />
            <div class="invalid-feedback">
                {{ getError('agudaPrice') }}
            </div>
        </div>
    </div>
</template>

<script>
import CurrencyInput from '@/components/elements/CurrencyInput';
import WysiwygEditor from '@/components/elements/WysiwygEditor';
import ContentBuilder from '@/components/elements/ContentBuilder';

export default {
    components: {
        CurrencyInput,
        WysiwygEditor,
        ContentBuilder
    },

    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            event: {},
            isAgudaPriceEnabled: false
        };
    },

    watch: {
        event() {
            this.$emit('input', this.event);
        },

        isAgudaPriceEnabled(value) {
            this.event.agudaPrice = value ? this.event.agudaPrice || 0 : null;
        }
    },

    created() {
        this.event = { ...this.value };

        this.isAgudaPriceEnabled = this.editMode
            ? this.event.agudaPrice !== null
            : false;

        if (this.event.date) {
            this.event.date = this.$dayjs(this.event.date).format(
                'YYYY-MM-DDTHH:mm'
            );
        }
    },

    methods: {
        hasError(key) {
            return (
                this.validation?.event[key]?.$error ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.event,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
